<template>
    <ExternalUser  />
</template>
<script>
import ExternalUser from "../../components/ExternalUser.vue";
export default {
	components: {
		ExternalUser
	},
}
</script>